<template>
  <div v-if="!contact.isHidden" class="endpage">
    <div class="block">
      <div class="title">{{ title }}</div>
      <div class="title">{{ contact.companyName }}</div>
      <div class="text" v-html="contact.address"></div>
      <div class="text contact-name">{{ contact.firstname }} {{ contact.lastname }}</div>
      <a :href="`tel:${contact.phoneNumber}`">
        <div class="text contact-phone">{{ contact.phoneNumber }}</div>
      </a>
      <a :href="`mailto:${contact.email}`" target="_blank">
        <div class="text contact-email">{{ contact.email }}</div>
      </a>
    </div>
    <div class="logo"></div>
  </div>
</template>

<script>
export default {
  name: 'EndPage',
  props: {
    resume: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contact: {},
      title: 'Powered by Washi',
      templatesWithoutPoweredByWashi: ['latelier', 'yeets', 'yeets2025', 'qacode'],
    };
  },
  watch: {
    resume: {
      handler: function (resume) {
        if (resume.contact) {
          this.contact = resume.contact;
        }

        this.title =
          resume.template && this.templatesWithoutPoweredByWashi.includes(resume.template.name)
            ? ''
            : 'Powered by Washi';
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.resume && this.resume.contact) {
      this.contact = this.resume.contact;
    }

    this.title =
      this.resume && this.resume.template && this.templatesWithoutPoweredByWashi.includes(this.resume.template.name)
        ? ''
        : 'Powered by Washi';
  },
};
</script>

<style scoped lang="scss"></style>
